import {
    GET_ZIP_REQUEST,
    GET_ZIP_SUCCESS,
    GET_ZIP_ERROR,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_ZIP_REQUEST:
            return {
                loading: true,
            };
        case GET_ZIP_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ZIP_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}